import { render, staticRenderFns } from "./BaseFrontOfficeWalletWrapper.vue?vue&type=template&id=21ea216d&scoped=true"
import script from "./BaseFrontOfficeWalletWrapper.vue?vue&type=script&lang=js"
export * from "./BaseFrontOfficeWalletWrapper.vue?vue&type=script&lang=js"
import style0 from "./BaseFrontOfficeWalletWrapper.vue?vue&type=style&index=0&id=21ea216d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21ea216d",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VContainer})
